<template>
  <span>{{name}}</span>
</template>
<script>
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    props: {
      locale: {
        type: String,
        default: 'es',
      },
      id: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        name: ''
      }
    },
    mounted () {
      if(this.id) this.handleGetContentName (this.id)
    },
    methods: {
      handleGetContentName (id) {  
        api.getItem(`menus/desktop-view/content-name`, true, id)
          .then(response => {
            const aux = response.FoodName ? utils.getTranslation(JSON.parse(response.FoodName), this.locale) : ''
            this.name = `(${aux})`
          })
          .catch(error => {
            console.log('error', error)
            return ''
          })
      },
    }
  }
</script>
